/**
 * Gemarun legacy stickers encode productCodeUnique as 8 zero-padded digits:
 *   left  = 5 digits, right = 3 digits  →  "5156/44" ↔ "05156044"
 * New CODE128 labels already contain the slash ("5156/44").
 */
const LEGACY_PADDED_CODE = /^\d{8}$/;

export function normalizeScannedProductCode(raw: string): string {
  const code = raw.trim();
  if (code.length === 0) {
    return code;
  }
  // New labels / manual entry with slash — keep literal.
  if (code.includes('/')) {
    return code;
  }
  if (!LEGACY_PADDED_CODE.test(code)) {
    return code;
  }

  // Strip padding zeros: "05156"+"044" → "5156/44"
  const left = String(Number(code.slice(0, 5)));
  const right = String(Number(code.slice(5, 8)));
  return `${left}/${right}`;
}
